import React, { useState, useEffect } from 'react'
import { Button } from '../ui/button'
import { Card } from '../ui/card'
import StepsIndicator from '../steps-indicator'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'src/config/routes'

export function EnrollmentSuccess() {
  const navigate = useNavigate()

  const redirectToDashboard = () => {
    //navigate(ROUTES.ADMIN.DASHBOARD)
    navigate(ROUTES.MERCHANT.DASHBOARD)
  }
  return (
    <div className="flex flex-col w-full gap-6 items-center">
      <div className="flex flex-col items-center mx-8 gap-2">
        <h1 className="text-2xl font-medium text-white">Congratulations!</h1>
        <div className="flex flex-col">
          <p className="text-slate-400 font-light text-center">You have completed all the steps.</p>
        </div>
      </div>
      {/* <StepsIndicator currentStep={3} /> */}
      <div className="mt-8">
        <div className="flex items-center justify-center w-12 h-12 rounded-full bg-[#10b77f] text-white">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-8 h-8"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        </div>
      </div>

      <p className="text-white font-normal leading-relaxed text-sm">You are all set, you can start using FanFair!</p>
      <Button className="w-full bg-[#570393] hover:bg-[#570393]/90 text-white" onClick={redirectToDashboard}>
        Launch FanFair
      </Button>
    </div>
  )
}
